import { useParams, Link } from 'react-router-dom';
import { categories, getArticlesByCategory, articles } from '@/mocks/articles';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const categoryArticles = slug ? getArticlesByCategory(slug) : [];

  if (!category) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
            <i className="ri-error-warning-line text-2xl"></i>
          </div>
          <h1 className="font-heading text-xl font-bold text-foreground-900 mb-2">分类未找到</h1>
          <p className="text-foreground-600 text-sm mb-6">你访问的分类不存在或已被移除</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${category.name} - 传教士体位完全指南`,
    description: category.description,
    url: `https://www.chuanjiaoshi-tiwei.com/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '传教士体位完全指南',
      url: 'https://www.chuanjiaoshi-tiwei.com/',
    },
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: categoryArticles.map((article, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        url: `https://www.chuanjiaoshi-tiwei.com/article/${article.slug}`,
        name: article.title,
      })),
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(webPageSchema)}</script>
      <main className="min-h-screen bg-background-50 pt-16">
        {}
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="w-full px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: category.name },
              ]}
            />
          </div>
          <div className="w-full px-4 md:px-6 py-10 md:py-14">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className={`${category.icon} text-xl`}></i>
                </div>
                <div>
                  <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
                    {category.name}
                  </h1>
                  <p className="text-foreground-600 text-sm mt-1">
                    {category.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {}
        <div className="w-full px-4 md:px-6 py-10">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-2 mb-8 flex-wrap">
              <span className="text-sm text-foreground-500 whitespace-nowrap">全部分类：</span>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-xs font-medium whitespace-nowrap transition-all duration-200 ${
                    cat.slug === slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-600'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {categoryArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {categoryArticles.map((article) => (
                  <ArticleCard key={article.id} article={article} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100 text-foreground-400">
                  <i className="ri-file-list-3-line text-2xl"></i>
                </div>
                <p className="text-foreground-600 text-sm">该分类下暂无文章</p>
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
}